import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetSaleDetailList, DownloadOilOrderList, BairunOrderRefund } from '@/api/bairun/saleDetail'; //  此处请自行替换地址

import { getBairunPayChannelList } from '@/api/bairun/bairunPayChannel';
import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import OrderStatusTag from '@/components/orderStatusTag';
import { Common } from '@/utils/common';
import SearchTerm from '@/components/searchTerm';
import { saveAs } from 'file-saver';

var _this;

export default {
  name: 'OilOrderDetail',
  filters: {
    formatDate: function formatDate(time, format) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, format || 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatDatePayAt: function formatDatePayAt(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationOption.length; i++) {
        if (_this.stationOption[i].ID === id) {
          return _this.stationOption[i].stationName;
        }
      }

      return '';
    }
  },
  components: {
    OrderStatusTag: OrderStatusTag,
    SearchTerm: SearchTerm
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: GetSaleDetailList,
      loading: false,
      downloading: false,
      searchItems: {
        // 按配置顺序显示
        'sellerOrderType': 1,
        'sellerId': '',
        'mainOrderNo': '',
        'mobile': '',
        'createdAtStart': '',
        'createdAtEnd': '',
        'oilGunNo': '',
        'oilCode': '',
        'payChannel': ''
      },
      type: '',
      refundDialogVisible: false,
      payChannelOption: [],
      stationOption: [],
      dateRangeValueArr: [],
      multipleSelection: [],
      formData: {},
      refundFormData: {}
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var stationOption, payChannelList;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('OilOrderDetail activity init');
                _context3.next = 3;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 3:
                stationOption = _context3.sent;
                _this3.stationOption = stationOption.data.list;
                _context3.next = 7;
                return getBairunPayChannelList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 7:
                payChannelList = _context3.sent;
                _this3.payChannelOption = payChannelList.data.list;
                _context3.next = 11;
                return _this3.getDict('orderStatus');

              case 11:
                _context3.next = 13;
                return _this3.getDict('refundStatus');

              case 13:
                _this3.formData = _this3.initData();
                _this3.refundFormData = _this3.initRefundData();

                if (JSON.stringify(_this.$route.params) !== '{}') {
                  _this.searchInfo = _this.$route.params;

                  _this3.getTableData();
                }

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    initData: function initData() {
      var formdata = {};
      return formdata;
    },
    initRefundData: function initRefundData() {
      var formdata = {
        'mainOrderNo': '',
        'tradePay': 0,
        'orderAmount': 0,
        'refundAmount': 0,
        'payChannel': 0
      };
      return formdata;
    },
    onSearch: function onSearch() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.page = 1;
                _this4.pageSize = 10;
                _this4.searchInfo = JSON.parse(JSON.stringify(_this4.searchItems));
                _this4.searchInfo.goodsNo = _this4.searchItems.oilGunNo;
                _this4.searchInfo.goodsType = _this4.searchItems.oilCode;
                delete _this4.searchInfo.oilGunNo;
                delete _this4.searchInfo.oilCode;
                _this4.loading = true;

                _this4.getTableData();

                _this4.loading = false;

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onSearchChange: function onSearchChange(formItem) {},
    onDownload: function onDownload() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.downloading = true;
                _context5.next = 3;
                return DownloadOilOrderList(_this5.searchInfo);

              case 3:
                res = _context5.sent;
                _this5.downloading = false;

                if (res.code == 0) {
                  saveAs(res.data.fileUrl);
                }

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    onRefund: function onRefund() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          type: 'warning',
          message: '请选择要操作的数据'
        });
        return;
      }

      this.refundFormData = JSON.parse(JSON.stringify(this.multipleSelection[0]));
      this.refundFormData.refundAmount = this.refundFormData.tradePay;
      this.refundDialogVisible = true;
      this.type = 'refund';
    },
    handleSelChange: function handleSelChange(val) {
      this.multipleSelection = val;
    },
    onInputRefundAmount: function onInputRefundAmount(e) {
      this.refundFormData.refundAmount = Common.formatMoney(this.refundFormData.refundAmount);
      this.inputChange(e);
    },
    closeDialog: function closeDialog() {
      this.type = '';
      this.refundDialogVisible = false;
      this.formData = this.initData();
      this.refundFormData = this.initRefundData();
    },
    enterDialog: function enterDialog() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(_this6.type === 'refund')) {
                  _context6.next = 17;
                  break;
                }

                if (_this6.refundFormData.refundAmount) {
                  _context6.next = 4;
                  break;
                }

                _this6.$message({
                  type: 'warning',
                  message: '实退金额不能为空'
                });

                return _context6.abrupt("return");

              case 4:
                if (_this6.refundFormData.payChannel) {
                  _context6.next = 7;
                  break;
                }

                _this6.$message({
                  type: 'warning',
                  message: '退款方式不能为空'
                });

                return _context6.abrupt("return");

              case 7:
                if (!(_this6.refundFormData.refundAmount > _this6.refundFormData.orderPay)) {
                  _context6.next = 10;
                  break;
                }

                _this6.$message({
                  type: 'warning',
                  message: '实退金额不能大于实付金额'
                });

                return _context6.abrupt("return");

              case 10:
                _context6.next = 12;
                return BairunOrderRefund({
                  'mainOrderNo': _this6.refundFormData.mainOrderNo,
                  'refundAmount': parseFloat(_this6.refundFormData.refundAmount),
                  'refundPayChannel': parseInt(_this6.refundFormData.payChannel)
                });

              case 12:
                res = _context6.sent;

                if (!(res.code == 0)) {
                  _context6.next = 17;
                  break;
                }

                _this6.$message({
                  type: 'success',
                  message: '申请已提交，待审批中'
                });

                _this6.closeDialog();

                return _context6.abrupt("return");

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  }
};